/* eslint-disable @next/next/no-img-element */
import React from 'react';
import { ASSET_PREFIX } from 'utils/constants';

export const Heading = ({ setShowDrawDaysPopup }) => {
  return (
    <p className="large bold">
      Which draw days?
      <img
        src={`${ASSET_PREFIX}/images/info-circle.svg`}
        className="infoIcon"
        onClick={() => setShowDrawDaysPopup(true)}
        alt="info"
      />
      <style jsx>
        {`
          .infoIcon {
            margin: 0 0.5em;
            min-width: 15px;
          }
        `}
      </style>
    </p>
  );
};
